import Pochta from "./Pochta";
function ENFP()
{
     return(
        <div className="Glavn">
  <div className='catalog' >
        <div className="image">
           <div className="image-wrapper">
      <img src="/img/ENFP Борец.png" className="ENFP"/>
      </div>
      {/* <h1>Дипломат</h1>
      <h2>ENFP</h2> */}
       <div className="result">
         <h2>ENFP</h2>
      <p><strong>Процент населения:</strong> 6–8%</p>
<p><strong>Среди мужчин:</strong> 4–5%</p>
<p><strong>Среди женщин:</strong> 7–10%</p>
<p><strong>Стратегия:</strong> Социальное взаимодействие</p>

<p><strong>Психологические особенности:</strong></p>
<p>
  ENFP черпают энергию из общения и новых впечатлений. 
  Компания друзей для них — не просто отдых, а способ восстановить внутреннюю энергию. 
  Они устают от одиночества и рутины.
</p>
<p>
  Решения ENFP принимают интуитивно, доверяя своему внутреннему компасу. 
  Они открыты миру, слушают своё сердце и редко действуют против своих ценностей.
</p>
<p>
  Это эмоциональные и впечатлительные люди. 
  Их голова постоянно полна идей, из-за чего они легко отвлекаются и часто переключаются между делами.
</p>

<p><strong>Особенность:</strong></p>
<p>
  ENFP — это ураган, который невозможно остановить. Они берутся за всё и не доводят до конца. 
  Их настроение меняется быстрее погоды. Они могут быть душой компании, а через час — плакать в углу. 
  Их непредсказуемость и импульсивность утомляют, но без них скучно.
</p>

<p>
  ENFP — это человек, который может превратить обычный вторник в приключение. 
  Они видят возможности там, где другие видят стену. Их энтузиазм заразителен, 
  а их вера в лучшее способна растопить лёд. Да, они могут забыть о важной встрече, 
  но они помнят, о чём ты мечтал 5 лет назад.
</p>

  </div>
  <Pochta/>
  </div>
   </div>
    </div>

       );
}
export default ENFP;